module.exports = __webpack_public_path__ + "img/af9d12cf92ef00b500848ab5c9dddc5b.svg";